import styles from "@css/modules/PointChart.module.scss"
import cn from "classnames"
import { useEffect, useRef, useState } from "react"
import { cellTypeClasses, useSticky } from "./utils"

export function ColumnDescriptions({ column_description, mobile }) {
    const [descriptions, setDescriptions] = useState([])
    const ref = useRef(null)
    useSticky(ref, mobile)
    useEffect(() => {
        const desc = []
        new Array(5).fill(0).forEach((_, key) => {
            const propKey = `points_${key + 1}_desc`
            if (column_description[propKey]) {
                const value = column_description[propKey]
                desc.push({
                    cls: cellTypeClasses[key + 1],
                    value: value
                })
            }
        })
        setDescriptions(desc)
    }, [column_description])
    let className = cn({
        [styles.cellDescriptionsMobile]: mobile,
        [styles.cellDescriptions]: !mobile
    })

    return (
        <div className={className} ref={ref}>
            {descriptions.map((i) => {
                return (
                    <div key={i.cls} className={styles.cellDescItem}>
                        <span className={i.cls} />
                        {i.value}
                    </div>
                )
            })}
        </div>
    )
}
